<script lang="ts">
  import { Button, ButtonDropdown,ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle } from "sveltestrap";
  import { Action, AnotherAction, BasicButtongroup, BasicButtongroupMessage, Buttondropdowns, ButtondropdownsMessage, ButtonswithIcon, ButtonswithIconMessage, Danger, DefaultButtons, DefaultButtonsMessage, Dropdownheader, ExpandAnimationButtons, ExpandUP, IconButton, LoadingButtons, Primary, RoundButtons, RoundButtonsMessage, Secondary, Separatedlink, SimpleIconButton, SomethingElseHere, Warning } from "../../../../utils/Constant/Constant";
</script>
<tr>
    <td>{'Button'}</td>
    <td class="w-50">
      <Button color="primary">{DefaultButtons}</Button>
    </td>
    <td><span>{DefaultButtonsMessage}</span></td>
</tr>
<tr>
    <td>{RoundButtons}</td>
    <td>
      <Button class="btn-pill" color="primary">{DefaultButtons}</Button>
    </td>
    <td><span>{@html RoundButtonsMessage}</span></td>
</tr>
<tr>
    <td>{Buttondropdowns}</td>
    <ButtonDropdown>
        <DropdownToggle caret color="primary">{Primary}</DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>{Dropdownheader}</DropdownItem>
          <DropdownItem>{Action}</DropdownItem>
          <DropdownItem>{AnotherAction}</DropdownItem>
          <DropdownItem>{SomethingElseHere}</DropdownItem>
          <DropdownItem divider />
          <DropdownItem>{Separatedlink}</DropdownItem>
        </DropdownMenu>
    </ButtonDropdown>
    <td>
        <span>{@html ButtondropdownsMessage}</span>
    </td>
</tr>
<tr>
    <td>{BasicButtongroup}</td>
    <td>
        <ButtonGroup>
        <Button color="primary">{Primary}</Button>
        <Button color="secondary">{Secondary}</Button>
        <Button color="danger">{Danger}</Button>
        <Button color="warning">{Warning}</Button>
        </ButtonGroup>
    </td>
    <td><span>{@html BasicButtongroupMessage}</span></td>
</tr>
<tr>
    <td>{ButtonswithIcon}</td>
    <td>
      <Button color="primary">
        <i class="fa fa-info-circle"></i> {Primary}
      </Button>
    </td>
    <td><span>{ButtonswithIconMessage}</span></td>
</tr>
<tr>
    <td>{IconButton}</td>
    <td>
      <Button color="primary"><i class="fa fa-camera"></i></Button>
    </td>
    <td><span>{SimpleIconButton}</span></td>
</tr>
<tr>
    <td>{LoadingButtons}</td>
    <td>
      <Button color="primary">
        <i class="fa fa-spin fa-spinner me-2"></i>{ExpandUP}</Button>
    </td>
    <td><span>{ExpandAnimationButtons}</span></td>
</tr>